import { Component, Vue } from 'vue-property-decorator'
import { queryforSetClass, joinClass, queryStudentDataBeforeEnter } from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
@Component({ name: 'join-class-detail-page' })
export default class JoinClassDetailPage extends Vue {
  private joinType = 0 // 入班方式
  private joinDialogVisible = false // 是否显示转案确认弹窗
  private studentId: any = null
  private classList = []
  private courseId: any = null
  private sellOrderId: any = null
  private classChoose: any = null
  private newClassName = null
  private sData: any = {}
  private time: any = null
  private informationListImg: any = []
  private joinDialog = false
  get className () {
    if (this.joinType * 1 === 1) {
      return this.newClassName
    } else if (this.joinType * 1 === 2) {
      const result: any = this.classList.filter((item: any) => { return item.classId === this.classChoose })
      return result.length > 0 ? result[0].className : ''
    }
  }

  created () {
    this.studentId = this.$route.query.id
    this.courseId = this.$route.query.courseId
    this.sellOrderId = this.$route.query.orderId
    this.initPageData()
  }

  private async initPageData () {
    const result = await queryStudentDataBeforeEnter({ sellOrderId: this.sellOrderId })
    this.sData = result
    this.getAllClass()
    // 简历部分预览【】
    const list1: any = JSON.parse(JSON.stringify(this.sData.resumeUrlList))
    const resumeUrlList: any = []
    list1.forEach((item: any) => {
      if (item) {
        const url = decodeURI(item)
        const str = url.split('/crm/')[1]
        if (str) {
          const name = str.slice(20)
          const obj = { name: name, url: item }
          resumeUrlList.push(obj)
        }
        if (this.fileExtension(item) === 'png' || this.fileExtension(item) === 'jpg' || this.fileExtension(item) === 'jpeg') {
          this.informationListImg.push(item)
        }
      }
    })
    this.sData.resumeUrlList = resumeUrlList
  }

  fileExtension = function (type: any) {
    return type.substring(type.lastIndexOf('.') + 1)
  }

  private async getAllClass () {
    const result: any = await queryforSetClass({ courseType: this.sData.courseTypeId, courseId: this.sData.courseId })
    this.classList = result
  }

  /**
   * [description] 转案按钮被点击
   */
  private async onJoinClick () {
    // 确定入班
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      this.joinDialog = true
      const param: any = { studentId: this.studentId, courseId: this.courseId, sellOrderId: this.sellOrderId }
      const type = this.joinType * 1
      if (type === 1) {
        param.newClassName = this.newClassName
      } else if (type === 2) {
        param.classId = this.classChoose
      }
      const { error }: any = await joinClass(param)
      if (!error) {
        this.$router.go(-1)
        TagsViewModule.delView(this.$route)
      }
      this.joinDialogVisible = false
    }, 300)
  }
}
